<template>
  <div class="my-pages-title">
    <h1 v-if="mq('medium')" class="my-pages-title__main">
      {{ title }}
    </h1>
    <button v-else class="my-pages-title__action" @click="goBack">
      <oie-use-svg
        svg="caret"
        css-classes="svg--180"
        height="15"
        width="15"></oie-use-svg>
      <h1 class="my-pages-title__main">
        {{ title }}
      </h1>
    </button>
    <p v-if="text" class="my-pages-title__text">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    goBack() {
      this.publish('my-pages-set-active-component', null)
    }
  }
}
</script>

<style lang="scss">
.my-pages-title__main {
  @include h2-semi-bold;
  margin: 0;
}

.my-pages-title__action {
  @include reset-button;

  svg {
    margin-right: measure(half);
  }
}

.my-pages-title__text {
  margin: measure(quarter) 0 0 0;
}
</style>
